/// In-run HUD: score + high-score corners, or centered gold score once beaten.

import { useThemeColors } from '@/settings/handler/settingsStore';
import { textShadow } from '@/ui/FlashText';
import { PixelIcon } from '@/ui/pixel/PixelIcon';
import { formatScore } from '@/utils/formatScore';

export interface GameHudProps {
  score: number;
  highScore: number;
  celebratingHighScore?: boolean;
}

export function GameHud({
  score,
  highScore,
  celebratingHighScore = false,
}: GameHudProps) {
  const colors = useThemeColors();
  const gold = colors.highScoreGold;

  return (
    <div className="flex h-10 items-center px-4">
      {celebratingHighScore ? (
        <div
          key="celebrate"
          className="flex w-full items-center justify-center gap-1.5"
          style={{ animation: 'dinodash-hud-in 350ms ease-out' }}
        >
          <PixelIcon name="trophy" set="pixel_icons" size={22} color={gold} />
          <span
            className="leading-none"
            style={{
              fontSize: 28,
              color: gold,
              textShadow: textShadow(colors.surface, 1.5),
            }}
          >
            {formatScore(score)}
          </span>
        </div>
      ) : (
        <div
          key="corners"
          className="flex w-full items-center"
          style={{ animation: 'dinodash-hud-in 350ms ease-out' }}
        >
          <span
            className="leading-none"
            style={{
              fontSize: 28,
              color: colors.onSurface,
              textShadow: textShadow(colors.surface, 1.5),
            }}
          >
            {formatScore(score)}
          </span>
          <div className="flex-1" />
          <div className="flex items-center gap-1">
            <PixelIcon name="trophy" set="pixel_icons" size={22} color={gold} />
            <span
              className="leading-none"
              style={{
                fontSize: 28,
                color: gold,
                textShadow: textShadow(colors.surface, 1.5),
              }}
            >
              {formatScore(highScore)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
